if (!customElements.get('mobile-product-menu')) {
  customElements.define(
    'mobile-product-menu',
    class MobileProductMenu extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.tabs = Array.from(this.querySelectorAll('[data-mobile-menu-tab]'));
        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.selectTab(tab));
          tab.addEventListener('keydown', (event) => this.onKeydown(event));
        });
      }

      selectTab(nextTab, moveFocus = false) {
        this.tabs.forEach((tab) => {
          const isActive = tab === nextTab;
          const panel = this.querySelector(`#${CSS.escape(tab.getAttribute('aria-controls'))}`);

          tab.setAttribute('aria-selected', String(isActive));
          tab.tabIndex = isActive ? 0 : -1;
          if (panel) panel.hidden = !isActive;
        });

        this.scrollTabIntoView(nextTab);
        if (moveFocus) nextTab.focus();
        this.closest('.menu-drawer__navigation-container')?.scrollTo({ top: 0, behavior: 'auto' });
      }

      scrollTabIntoView(tab) {
        const scroller = this.querySelector('.mobile-product-menu__tabs-scroller');
        if (!scroller) return;

        const scrollerRect = scroller.getBoundingClientRect();
        const tabRect = tab.getBoundingClientRect();
        const nextLeft =
          scroller.scrollLeft + (tabRect.left - scrollerRect.left) - scrollerRect.width / 2 + tabRect.width / 2;

        scroller.scrollTo({ left: Math.max(0, nextLeft), behavior: 'smooth' });
      }

      onKeydown(event) {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();

        const currentIndex = this.tabs.indexOf(event.currentTarget);
        let nextIndex = currentIndex;

        if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;

        this.selectTab(this.tabs[nextIndex], true);
      }
    }
  );
}

if (!customElements.get('desktop-product-menu')) {
  customElements.define(
    'desktop-product-menu',
    class DesktopProductMenu extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.tabs = Array.from(this.querySelectorAll('[data-desktop-menu-tab]'));
        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.selectTab(tab));
          tab.addEventListener('keydown', (event) => this.onKeydown(event));
        });
      }

      selectTab(nextTab, moveFocus = false) {
        this.tabs.forEach((tab) => {
          const isActive = tab === nextTab;
          const panel = this.querySelector(`#${CSS.escape(tab.getAttribute('aria-controls'))}`);

          tab.setAttribute('aria-selected', String(isActive));
          tab.tabIndex = isActive ? 0 : -1;
          if (panel) panel.hidden = !isActive;
        });

        if (moveFocus) nextTab.focus();
      }

      onKeydown(event) {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();

        const currentIndex = this.tabs.indexOf(event.currentTarget);
        let nextIndex = currentIndex;

        if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;

        this.selectTab(this.tabs[nextIndex], true);
      }
    }
  );
}
